export function getPhoneNumberDigits(phoneNumber?: string) {
  return (phoneNumber ?? '').replace(/\D/g, '');
}

export function isPhoneNumberComplete(phoneNumber?: string) {
  const digitsOnly = getPhoneNumberDigits(phoneNumber);
  const normalizedPhoneNumber =
    digitsOnly.startsWith('55') && digitsOnly.length > 11 ? digitsOnly.slice(2) : digitsOnly;

  return normalizedPhoneNumber.length >= 10;
}

export function formatPhoneNumber(phoneNumber?: string) {
  if (!phoneNumber) {
    return '';
  }

  const digitsOnly = getPhoneNumberDigits(phoneNumber);
  const normalizedPhoneNumber =
    digitsOnly.startsWith('55') && digitsOnly.length > 11 ? digitsOnly.slice(2) : digitsOnly;

  if (normalizedPhoneNumber.length < 10) {
    return phoneNumber;
  }

  const ddd = normalizedPhoneNumber.slice(0, 2);
  const localNumber = normalizedPhoneNumber.slice(2);

  if (localNumber.length === 9) {
    return `(${ddd}) ${localNumber.slice(0, 5)}-${localNumber.slice(5)}`;
  }

  if (localNumber.length === 8) {
    return `(${ddd}) ${localNumber.slice(0, 4)}-${localNumber.slice(4)}`;
  }

  return `(${ddd}) ${localNumber}`;
}
